
import { Container, Typography, Paper, Box } from "@mui/material";

import KittenFamily from "../components/KittenFamily";
import { litters } from "../data/makeData";

function HomePage() {
  return (
    <>
      <Container sx={{ py: 4 }}>
        <Box sx={{ p: 3, flexGrow: 1 }}>
          { 
            /*
            <Typography variant="h3" gutterBottom align="center">
            Chandani's Thai Kissala
            </Typography>
          */
          }
          <Typography variant="subtitle1" align="center" gutterBottom>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique unde
            fugit veniam eius, perspiciatis sunt? Corporis qui ducimus quibusdam,
            aliquam dolore excepturi quae. Distinctio enim at eligendi perferendis in
            cum quibusdam sed quae, accusantium et aperiam? Quod itaque exercitationem,
            at ab sequi qui modi delectus quia corrupti alias distinctio nostrum.
            Minima ex dolor modi inventore sapiente necessitatibus aliquam fuga et.
          </Typography>
        </Box>
      </Container>
      <Paper elevation={0} square>
        {
          Object.values(litters).map((litter) => {
            return (
              <KittenFamily key={litter.name} name={litter.name} litter={litter} defaultExpanded />
            )
          })
        }
      </Paper>
    </>
  );
}


export default HomePage;